import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import '../styles/home.css';
import piechart from '../images/piechart.png';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <Container className="home-container">
      <div className="homeContent">
        <Helmet>
          <title>Datagenetx | Home</title>
        </Helmet>
        <div>
          <h1 className="mt-5 text-center">
            Turn Your <span>DATA</span> into <span>Revenue</span>
          </h1>
          <img src={piechart} alt="piechart" className="piechart" />
        </div>
        <h4>Overview</h4>
        <p>
          The purpose of this new system is to align the EmailDrop project
          functionality with its current and future needs for accepting and
          distributing data records. Over the years EmailDrop had evolved to be
          a central hub for all of the data moving through LeadVision Media with
          data sources from owned sites such as MyDegree and MyFastQuote as well
          as from single individuals or companies sending in records. This
          system will now become Datagenetx.
        </p>{' '}
        <p>
          EmailDrop currently serves the purpose of <strong>cleaning</strong>{' '}
          incoming records by running emails through one or more third party
          validation APIs and <strong>sorting</strong> the records into separate
          lists based on source. In addition, an unsubscribe database table
          tracks email records that should be excluded from marketing.{' '}
        </p>
        <p>
          Another primary focus of EmailDrop is <strong>distributing</strong>{' '}
          collected data to various third party mail platforms (ESPs) for
          marketing such as MailChimp or Convertkit. A set of rules allow for
          distributing a record to one or more ESPs as well as throttling and
          schedules. Records can be distributed as they come into EmailDrop in
          real time, or by list where stored records can be processed at a later
          date.
        </p>
        <p className="mb-5">
          An endpoint for “subscribing” is provided for each list and accepts a
          POST request with a number of common user fields which are stored in
          EmailDrop. There is also a public endpoint for “unsubscribing”, which
          adds an email address to the data_unsub_list table. New records are
          checked against this table before distributing to ESPs.{' '}
        </p>
        <h4>Admin</h4>
        <p>
          The current admin provides the interface for employees to manage all
          data. The dashboard displays a queue status for outgoing data to an
          ESP, statistics for data records sold to third parties, as well as a
          live log of records running through the system. Under lists, new lists
          can be created using a source or company name. Current lists are
          displayed, and a modal provides list details including a posting URL.
          The ability to review and edit privacy requests should be moved over
          from the old admin as well.
        </p>
        <Link className="getStartedBtn p-3 mt-5 mb-5" to="/signup">
          Get Started With Datagenetx
        </Link>
      </div>
    </Container>
  );
}

export default Home;
